// Checkbox (job page round): a 16 px box, ticked in ink, with its words beside it: "The customer can see
// this" in the photo viewer, a task done. The words may run to two lines (a task and its due date); the
// box sits on the first. React Aria draws the behaviour (Space toggles, the focus ring only for the
// keyboard). Size touch-on-phone is for one that stands as a form's row (a new customer's consent): at
// phone widths its row is a touch target, 44 tall, as the library's touch controls are. Reads only --check-*.
import type { ReactNode } from 'react';
import { Checkbox as AriaCheckbox } from 'react-aria-components';
import { Glyph } from '../Glyph/Glyph.tsx';
import './Checkbox.css';

export interface CheckboxProps {
  children: ReactNode;
  isSelected?: boolean;
  defaultSelected?: boolean;
  onChange?: (isSelected: boolean) => void;
  isDisabled?: boolean;
  /** Its name for screen readers when the words alone don't say it ("Done: Book the inspection"). */
  'aria-label'?: string;
  /** inline: the box and words alone; touch-on-phone: a row 44 tall at phone widths. */
  size?: 'inline' | 'touch-on-phone';
}

export function Checkbox({ children, size = 'inline', ...props }: CheckboxProps) {
  return (
    <AriaCheckbox className="fl-check" data-size={size === 'inline' ? undefined : size} {...props}>
      {({ isSelected }) => (
        <>
          <span className="fl-check__box" aria-hidden="true">
            {isSelected ? <Glyph name="check" className="fl-check__tick" /> : null}
          </span>
          <span className="fl-check__label">{children}</span>
        </>
      )}
    </AriaCheckbox>
  );
}
